import React, { useState, useRef, useEffect } from "react";
import {
  Dropdown,
  DropdownToggle,
  DropdownMenu,
  DropdownItem,
  Spinner,
  Alert,
  Container,
  Button,
  Table,
  Row,
  Col,
  Input,
} from "reactstrap";
import readXlsxFile from "read-excel-file";
import axios from "axios";
import { Cookies } from "react-cookie";
import { isValidExcelData, setFieldIndex } from "../../../utils/CheckValidData";

const cookies = new Cookies();

function AddExcelOrderForm({ handleReset }) {
  const [wholesalers, setWholesalers] = useState([]);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const [selectedWholesaler, setSelectedWholesaler] = useState(null);
  const [showUploadForm, setShowUploadForm] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  const [deliveryCodes, setDeliveryCodes] = useState([]);
  const [isLoadingDeliveryCodes, setIsLoadingDeliveryCodes] = useState(false);

  const [isShowUploadForm, setIsShowUploadForm] = useState(true);

  const [products, setProducts] = useState([]);
  const [ordersValid, setOrdersValid] = useState(true);

  const [checkProductNameOrderArr, setCheckProductNameOrderArr] = useState([]);

  const [isLoadingUplaod, setIsLoadingUpload] = useState(false);
  const [orderList, setOrderList] = useState([]);

  const fileInputRef = useRef(null);

  useEffect(() => {
    getWholesaler();
  }, []);

  const getWholesaler = async () => {
    try {
      const resList = await axios.get(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/admin/company`,
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        },
      );

      if (resList.data.companies) {
        setWholesalers(resList.data.companies);
      } else {
        setWholesalers([]);
      }
    } catch (error) {
      console.error("데이터를 불러오는데 실패했습니다", error);
    }
  };

  const toggleDropdown = () => {
    setDropdownOpen((prevState) => !prevState);
    if (!dropdownOpen) {
      // 드롭다운이 열릴 때 검색어 초기화
      setSearchTerm("");
    }
  };

  const handleWholesalerSelect = (wholesaler, e) => {
    if (e) {
      e.preventDefault();
      e.stopPropagation();
    }
    // 드롭다운을 먼저 닫기
    setDropdownOpen(false);
    setSearchTerm("");
    // 상태 업데이트
    setSelectedWholesaler(wholesaler);
    setShowUploadForm(true);
  };

  // 검색어로 필터링된 업체 목록
  const filteredWholesalers = wholesalers.filter((w) =>
    w.wholesaler.toLowerCase().includes(searchTerm.toLowerCase()),
  );

  const readUploadFile = async (e) => {
    // 초기화
    setOrderList([]);
    setIsLoadingUpload(true);
    setIsShowUploadForm(false);
    let isValidFile = true;

    // 1단계 : 엑셀데이터 rows에 담기
    const rows = await readXlsxFile(e.target.files[0])
      .then((resRows) => {
        return resRows;
      })
      .catch((err) => {
        console.log("err is", err);
      });

    fileInputRef.current.value = "";

    // 2단계 : 데이터 유효성 검사
    if (!rows) {
      alert("주문서 파일을 읽을 수 없습니다.");
      setIsLoadingUpload(false);
      return;
    }

    let resIsValidExcelData = isValidExcelData(rows);

    //   유효성 검사에 문제가 있는 경우 재 업로드 유도
    if (!resIsValidExcelData.isValid) {
      setIsLoadingUpload(false);
      isValidFile = false;
      alert(resIsValidExcelData.data.msg);
      return;
    }

    let tempOrderList = [];
    let tempOrdersObj = {};
    let tempNo = 0;
    let tempNoArr = [];
    let tempProductArr = [];
    let tempItems = [];
    let tempReceiverGroup = [];
    let tempAddressGroup = [];
    const fieldIndex = setFieldIndex(rows[0]); //필드별 인덱스 설정

    // 엑셀 날짜 형식을 문자열로 변환하는 헬퍼 함수
    const convertToString = (value) => {
      if (value === null || value === undefined) {
        return "";
      }
      if (value instanceof Date) {
        const year = value.getFullYear();
        const month = String(value.getMonth() + 1).padStart(2, "0");
        const day = String(value.getDate()).padStart(2, "0");
        return `${year}-${month}-${day}`;
      }
      return String(value).replace(/[\r\n]+/g, "").trim();
    };

    // 데이터 검증 후 row 단위로 데이터 저장하기
    for (let idx = 0; idx < rows.length; idx++) {
      const row = rows[idx];
      try {
        // 엑셀파일 2번째 행부터 각각의 필요한 필드 저장하기
        if (idx !== 0) {
          let no = row[fieldIndex["no"]];
          let productCode = row[fieldIndex["item"]["productCode"]];

          // 제품 코스 수집

          if (
            productCode !== "BRING" &&
            productCode !== "PROMO" &&
            productCode !== "CHEMIST" &&
            productCode !== "MART" &&
            productCode !== "SPECIAL" &&
            productCode !== ""
          ) {
            tempProductArr.push(productCode);
          }

          // 주문된 제품 내용
          let item = {
            productCode,
            productName: row[fieldIndex["item"]["productName"]],
            qauntity: row[fieldIndex["item"]["qauntity"]],
          };

          // No 값이 있는 경우 object를 만들고 주문정보를 추가하고, 값이 없는 경우 이미 만들어진 key에 아이템만 추가한다.
          if (no) {
            // 번호가 있는 행
            tempItems = []; //임시 items 초기화
            tempNo = no; //임시 No 설정

            tempItems.push(item);
            tempNoArr.push(no);

            // let wholesalerMemo = row[fieldIndex["wholesalerMemo"]];
            // let customerName = row[fieldIndex["customerName"]];
            // let pcc = row[fieldIndex["pcc"]];
            // let customerTel = row[fieldIndex["customerTel"]].replaceAll(
            //   "~",
            //   "-"
            // );
            // let customerMobile = row[fieldIndex["customerMobile"]].replaceAll(
            //   "~",
            //   "-"
            // );
            // let zipCode = row[fieldIndex["zip"]].toString();
            // if (zipCode.length === 4) {
            //   zipCode = "0" + zipCode;
            // }
            // let address = row[fieldIndex["address"]];
            // let deliveryMemo = row[fieldIndex["memo"]];
            // let commerceOrderNo = row[fieldIndex["commerceOrderNo"]];

            let wholesalerMemo = convertToString(
              row[fieldIndex["wholesalerMemo"]],
            );
            let customerName = convertToString(row[fieldIndex["customerName"]]);
            let pcc = convertToString(row[fieldIndex["pcc"]]);
            let customerTel = convertToString(
              row[fieldIndex["customerTel"]],
            ).replaceAll("~", "-");
            // 전화번호가 10으로 시작하는 경우 앞에 0 추가
            let telNumbersOnly = customerTel.replace(/-/g, "");
            if (
              telNumbersOnly.startsWith("10") &&
              telNumbersOnly.length >= 10
            ) {
              customerTel = "0" + customerTel;
            }
            let customerMobile = convertToString(
              row[fieldIndex["customerMobile"]],
            ).replaceAll("~", "-");
            // 모바일번호가 10으로 시작하는 경우 앞에 0 추가
            let mobileNumbersOnly = customerMobile.replace(/-/g, "");
            if (
              mobileNumbersOnly.startsWith("10") &&
              mobileNumbersOnly.length >= 10
            ) {
              customerMobile = "0" + customerMobile;
            }
            let zipCode = convertToString(row[fieldIndex["zip"]]);
            if (zipCode.length === 4) {
              zipCode = "0" + zipCode;
            }
            let address = convertToString(row[fieldIndex["address"]]);
            let deliveryMemo = convertToString(row[fieldIndex["memo"]]);
            let commerceOrderNo = convertToString(
              row[fieldIndex["commerceOrderNo"]],
            );

            // 필수값 검증
            const missingFields = [];
            if (!customerName || customerName.trim() === "") {
              missingFields.push("이름");
            }
            if (!customerMobile || customerMobile.trim() === "") {
              missingFields.push("모바일번호");
            }
            if (!zipCode || zipCode.trim() === "") {
              missingFields.push("우편번호");
            }
            if (!address || address.trim() === "") {
              missingFields.push("주소");
            }
            if (!pcc || pcc.trim() === "") {
              missingFields.push("통관부호");
            }

            if (missingFields.length > 0) {
              alert(
                `번호 ${no}의 필수값이 누락되었습니다.\n누락된 필드: ${missingFields.join(", ")}\n\n엑셀 파일을 확인 후 다시 업로드해주세요.`,
              );
              isValidFile = false;
              setOrderList([]);
              setIsLoadingUpload(false);
              setIsShowUploadForm(true);
              break;
            }

            const tooLongFields = [];
            if (customerTel.length > 20)
              tooLongFields.push(`전화번호(${customerTel.length}자)`);
            if (customerMobile.length > 20)
              tooLongFields.push(`모바일번호(${customerMobile.length}자)`);
            if (pcc.length > 20)
              tooLongFields.push(`통관부호(${pcc.length}자)`);

            if (tooLongFields.length > 0) {
              alert(
                `번호 ${no}의 입력값이 너무 깁니다 (최대 20자).\n해당 필드: ${tooLongFields.join(", ")}\n\n엑셀 파일을 확인 후 다시 업로드해주세요.`,
              );
              isValidFile = false;
              setOrderList([]);
              setIsLoadingUpload(false);
              setIsShowUploadForm(true);
              break;
            }

            // 주문정보
            tempOrdersObj[no] = {
              no,
              wholesalerMemo,
              customerName,
              customerTel,
              customerMobile,
              pcc,
              zipCode,
              address,
              deliveryMemo,
              items: tempItems,
              commerceOrderNo,
            };

            // 통관부호 유효성 확인을 위한 정보
            tempReceiverGroup.push({
              hawb: no,
              customerName,
              customerTel,
              customerMobile,
              pcc,
            });

            // 집배코드를 가져오기 위한 정보
            tempAddressGroup.push({
              id: no,
              zip: zipCode,
              address,
            });
          } else {
            // 번호가 없는 행
            tempItems.push(item);
            tempOrdersObj[tempNo]["items"] = tempItems;
          }
        }
      } catch (err) {
        console.log(err);
      }
    }

    // 제품코드별 제품정보 가져오기(코드, 영문명, 가격)
    let uniqueProductCode = [...new Set(tempProductArr)];

    // 제품정보 가져오기
    let tempProducts = null;
    await axios
      .post(
        `${process.env.REACT_APP_WHOLESALE_API_URL}/wholesale/search/price`,
        {
          grade: selectedWholesaler.purchase_grade,
          productCodes: uniqueProductCode,
        },
        {
          headers: {
            Authorization: cookies.get("info").token,
          },
        },
      )
      .then((data) => {
        if (data.data.res === "success") {
          tempProducts = data.data.data;
          setProducts(tempProducts);
        } else {
          // alert("제품정보가 없음, 작성하신 제품코드를 확인해 주세요.");
          // return;
        }
      })
      .catch((Error) => {
        console.log(Error);
      });

    // 파일에 정보가 정상인 경우 다음 단계 진행
    if (isValidFile) {
      // 집배코드 가져오기
      const getDeliveryCode = await axios
        .post(`${process.env.REACT_APP_UTILS_API_URL}/gendeliverycode`, {
          addressgroup: tempAddressGroup,
        })
        .then((data) => {
          setIsLoadingDeliveryCodes(false);
          return data.data;
        })
        .catch((Error) => {
          console.log(Error);
        });
      setDeliveryCodes(getDeliveryCode.resultArr);

      // 집배코드 분석 만약, 집배코드를 못가져오는 주소가 있다면 주문불가처리
      getDeliveryCode.resultArr.map((d) => {
        if (d.res === "fail") {
          setOrdersValid(false);
        }
      });

      // 통관부호 유효성 검사
      const checkPccValid = await axios
        .post(`${process.env.REACT_APP_UTILS_API_URL}/checkpcc/agg4`, {
          receivers: tempReceiverGroup,
        })
        .then((data) => {
          return data.data;
        })
        .catch((Error) => {
          console.log(Error);
        });

      // DB에 저장할 주문데이터 생성하기. 운송장번호 기준으로 저장된 주문아이템과 집배코드를 합친 형태의 데이터
      let tempCheckProductNameOrderArr = [];

      tempOrderList = tempNoArr.map((no) => {
        // 제품명 확인 : 상품코드에 적합한 상품명 확인, 서로 다른경우 제품코드 배열에 추가하기 checkProductNameOrderArr
        tempOrdersObj[no].items.map((i) => {
          if (tempProducts) {
            const dbName = tempProducts[i.productCode]?.name?.trim() ?? "";
            const excelName = i.productName?.trim() ?? "";
            tempProducts.hasOwnProperty(i.productCode) &&
              dbName !== excelName &&
              tempCheckProductNameOrderArr.push({
                no,
                customer: tempOrdersObj[no].customerName,
                productName: tempProducts[i.productCode].name,
                wrongProductName: i.productName,
              });
          }
        });

        return {
          ...tempOrdersObj[no],
          deliveryCode: getDeliveryCode.resultObj[no],
          pccValid: checkPccValid.resultObj[no],
        };
      });

      setCheckProductNameOrderArr(tempCheckProductNameOrderArr);
      setOrderList(tempOrderList);

      setIsLoadingUpload(false);
    }
  };

  // 주문건별 총 상품금액 계산함수
  const genAmount = (items) => {
    let amount = 0.0;

    items.map((item) => {
      let price = convertPriceFormat(
        item.productCode,
        item.productName,
        item.qauntity,
      ).replace("$", "");
      if (!isNaN(price)) {
        amount += parseFloat(price);
      }
    });

    return amount;
  };

  const convertPriceFormat = (productCode, productName, qauntity) => {
    let resValue = null;
    if (!productCode) {
      return "미정";
    }
    let pcode = productCode.toUpperCase();

    // 예외처리 코드 : BRING, CHEMIST, MART, PROMO, SPECIAL, 공백
    if (pcode === "BRING" || pcode === "PROMO") {
      resValue = "$0";
    } else if (
      pcode === "CHEMIST" ||
      pcode === "MART" ||
      pcode === "SPECIAL" ||
      pcode === ""
    ) {
      resValue = "미정";
    } else {
      // 제품키가 있는지 확인하고 있으면 가격정도 리턴, 없으면 코드없음으로 리턴
      if (products.hasOwnProperty(pcode) === true) {
        resValue =
          "$" +
          parseFloat(products[pcode]["price"] * qauntity)
            .toFixed(2)
            .toString();
      } else {
        resValue = "코드 없음";
      }
    }

    return resValue;
  };

  const handleCancel = () => {
    setOrderList([]);
    setIsShowUploadForm(true);
    setOrdersValid(true);
  };

  const handleSave = async () => {
    // 집배코드가 정확한 경우 등록하고, 그렇지 않은 경우 Alert으로 안내
    if (ordersValid) {
      // 저장할 때, 각 주문제품마다 단가정보 추가하기
      let tempOrders = orderList;
      let finalOrders = [];

      tempOrders.map((order) => {
        let tempOrder = order;
        let tempItemsArr = [];
        order.items.map((item) => {
          let tempItem = item;
          // 상품별 가격정보 넣기
          tempItem["unitPrice"] =
            products.hasOwnProperty(item.productCode) === true
              ? products[item.productCode].price
              : 0;
          // 상품코드에 맞는 상품명 넣기
          tempItem["productName"] = products.hasOwnProperty(item.productCode)
            ? products[item.productCode].name
            : tempItem["productName"];

          tempItemsArr.push(tempItem);
        });
        tempOrder["items"] = tempItemsArr;

        finalOrders.push(tempOrder);
      });

      // 통관부호 유효성 검사
      await axios
        .post(
          `${process.env.REACT_APP_WHOLESALE_API_URL}/wholesale`,
          {
            orders: finalOrders,
            email: selectedWholesaler.manager_email,
            wholesaler: selectedWholesaler.wholesaler,
          },
          {
            headers: {
              Authorization: cookies.get("info").token,
            },
          },
        )
        .then((data) => {
          if (data.data.result === "success") {
            // 저장 후 모달 창 찾고, 데이터 불러오기
            handleReset();
          }
        })
        .catch((Error) => {
          console.log(Error);
        });
    } else {
      alert("주소와 우편번호를 확인 후 다시 등록해주세요. ");
    }
  };

  return (
    <div>
      {/* 업체 선택 */}
      <Table>
        <tbody>
          <tr>
            <td style={{ width: "200px", fontSize: "1.1rem" }}>
              1단계 : 업체선택
            </td>
            <td>
              <Dropdown isOpen={dropdownOpen} toggle={toggleDropdown}>
                <DropdownToggle caret color="primary">
                  {selectedWholesaler
                    ? selectedWholesaler.wholesaler
                    : "업체 선택"}
                </DropdownToggle>
                <DropdownMenu
                  style={{
                    maxHeight: "400px",
                    overflowY: "auto",
                    minWidth: "250px",
                  }}
                >
                  <div
                    style={{
                      padding: "8px",
                      position: "sticky",
                      top: 0,
                      backgroundColor: "white",
                      zIndex: 1,
                    }}
                  >
                    <Input
                      type="text"
                      placeholder="업체명 검색..."
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      onClick={(e) => e.stopPropagation()}
                      onFocus={(e) => e.stopPropagation()}
                      style={{ marginBottom: "8px" }}
                    />
                  </div>
                  {filteredWholesalers.length > 0 ? (
                    filteredWholesalers.map((w, index) => (
                      <DropdownItem
                        key={index}
                        onClick={(e) => handleWholesalerSelect(w, e)}
                      >
                        {w.wholesaler}
                      </DropdownItem>
                    ))
                  ) : (
                    <DropdownItem disabled>
                      {searchTerm ? "검색 결과가 없습니다" : "업체가 없습니다"}
                    </DropdownItem>
                  )}
                </DropdownMenu>
              </Dropdown>
            </td>
          </tr>
        </tbody>
      </Table>
      {/* 업체를 선택한 경우 Excel Upload 폼 출력 */}
      {showUploadForm && (
        <Table>
          <tbody>
            <tr>
              <td style={{ width: "200px", fontSize: "1.1rem" }}>
                2단계 : 파일 업로드
              </td>
            </tr>
            <tr>
              <td>
                <div
                  className="mt-3"
                  style={{ display: isShowUploadForm && "hidden" }}
                >
                  <form className="p-5 border">
                    <label htmlFor="upload">엑셀파일 업로드</label>
                    <input
                      type="file"
                      name="upload"
                      id="upload"
                      ref={fileInputRef}
                      onChange={readUploadFile}
                    />
                  </form>
                </div>
              </td>
            </tr>
          </tbody>
        </Table>
      )}
      {isLoadingUplaod && (
        <>
          <p>통관번호 확인 및 집배코드 가져오는 중</p>
          <Spinner className="m-5" color="primary">
            Loading...
          </Spinner>
        </>
      )}

      {orderList && orderList.length > 0 && (
        <>
          <h4 className="mt-5">주문목록 ({orderList.length}건)</h4>
          {checkProductNameOrderArr && checkProductNameOrderArr.length > 0 && (
            <Alert color="danger">
              [상품코드와 상품명이 다른 주문건 확인]
              {checkProductNameOrderArr.map((p, idx) => {
                return (
                  <li key={idx}>
                    번호 : {p.no}({p.customer}),{" "}
                    <span className="text-danger">
                      상품명(수정) : {p.productName}
                    </span>
                    ,{" "}
                    <span className="text-info">
                      상품명(원본) : {p.wrongProductName}
                    </span>
                  </li>
                );
              })}
            </Alert>
          )}
          <Table hover bordered className="mt-3">
            <thead className="fontsize_14px">
              <tr className="table-primary">
                <th className="text-center p-2 border">번호</th>
                <th className="text-center p-2 border">요청메모</th>
                <th className="text-center p-2 border">이름</th>
                <th className="text-center p-2 border">전화번호</th>
                <th className="text-center p-2 border">모바일번호</th>
                <th className="text-center p-2 border">통관부호</th>
                {/* <th className="text-center p-2 border">통관부호 확인</th> */}
                <th className="text-center p-2 border">우편번호</th>
                <th className="text-center p-2 border">주소</th>
                {/* <th className="text-center p-2 border">집배코드</th> */}
                <th className="text-center p-2 border">배송메모</th>
                <th className="text-center p-2 border">주문상품</th>
                <th className="text-center p-2 border">
                  예상금액
                  <br />
                  (배송비 제외)
                </th>
                <th className="text-center p-2 border">쇼핑몰주문번호</th>
              </tr>
            </thead>
            <tbody className="fontsize_12px">
              {orderList.map((o, idx) => {
                return (
                  <tr key={idx}>
                    <td className="text-center">{o.no}</td>
                    <td className="text-center">{o.wholesalerMemo}</td>
                    <td className="text-center">{o.customerName}</td>
                    <td className="text-center">{o.customerTel}</td>
                    <td className="text-center">{o.customerMobile}</td>
                    <td className="text-center">{o.pcc}</td>
                    {/* <td
                      className="text-center"
                      style={{
                        fontWeight: "600",
                        background: o.pccValid.isValid === false && "#FA5858",
                      }}
                    >
                      {o.pccValid.isValid === false ? (
                        o.pccValid.data.reason
                      ) : (
                        <>정상 </>
                      )}
                    </td> */}
                    <td className="text-center">{o.zipCode}</td>
                    <td>{o.address}</td>
                    {/* <td
                      style={{
                        background: o.deliveryCode.res === "fail" && "#FA5858",
                      }}
                    >
                      {o.deliveryCode.res === "fail" ? (
                        "주소와 우편번호 확인필요"
                      ) : (
                        <>
                          {" "}
                          {o.deliveryCode.deliveryPoint}{" "}
                          {o.deliveryCode.centerPoint}{" "}
                          {o.deliveryCode.deliveryAreaCd}{" "}
                          {o.deliveryCode.courseNo}{" "}
                        </>
                      )}
                    </td> */}

                    <td>{o.deliveryMemo}</td>
                    <td style={{ padding: "0px" }}>
                      <Table bordered style={{ margin: "0px", width: "100%" }}>
                        <tbody>
                          {o.items.map((i, index) => {
                            return (
                              <tr key={index}>
                                <td
                                  className="text-center"
                                  style={{ width: "70px" }}
                                >
                                  {i.productCode}
                                </td>

                                <td className="cell">
                                  {products.hasOwnProperty(i.productCode) &&
                                  (products[i.productCode].name?.trim() ??
                                    "") !== (i.productName?.trim() ?? "") ? (
                                    <span className="text-danger">
                                      {products[i.productCode].name}
                                    </span>
                                  ) : (
                                    <span>{i.productName}</span>
                                  )}
                                </td>
                                <td
                                  style={{ width: "60px" }}
                                  className="text-center"
                                >
                                  {i.qauntity}개
                                </td>
                                <td
                                  style={{ width: "70px" }}
                                  className="text-center"
                                >
                                  {convertPriceFormat(
                                    i.productCode,
                                    i.productName,
                                    i.qauntity,
                                  )}
                                </td>
                              </tr>
                            );
                          })}
                        </tbody>
                      </Table>
                    </td>
                    <td className="text-center">
                      ${genAmount(o.items).toFixed(2)}
                    </td>
                    <td className="text-center">{o.commerceOrderNo}</td>
                  </tr>
                );
              })}
            </tbody>
          </Table>
        </>
      )}

      {orderList.length > 0 && (
        <>
          <Container>
            {" "}
            <Row>
              <Col>
                <div className="p-3 text-center">
                  <span
                    style={{ fontSize: "2rem", textDecoration: "underline" }}
                  >
                    총 주문 건수 : {orderList.length}건
                  </span>
                </div>
              </Col>
            </Row>
            <Row>
              <Col>
                <Button
                  onClick={() => handleCancel()}
                  className="mt-3"
                  color="secondary"
                  size="lg"
                  block
                >
                  취소
                </Button>
              </Col>
              <Col>
                <Button
                  onClick={() => handleSave()}
                  className="mt-3"
                  color="primary"
                  size="lg"
                  block
                >
                  주문서 등록
                </Button>
              </Col>
            </Row>
          </Container>
        </>
      )}
    </div>
  );
}

export default AddExcelOrderForm;
